<template>
  <div style="width: 100%">
    <b-crud :controller="controller" v-slot="{ ctrl }">
      <h3>{{ title }}</h3>
      <v-form @submit.prevent="submit(ctrl)">
        <v-row
          v-for="(row, rowIdx) in ctrl.formLayout"
          :key="'row-' + rowIdx"
          class="mt-1"
        >
          <v-col
            :cols="col.cols"
            v-for="(col, colIdx) in row.columns"
            :key="`row-${rowIdx}-col-${colIdx}`"
          >
            <component
              :formData="ctrl.formData"
              class="form-item"
              :column="col"
              :is="col.type === undefined ? 'f-text' : 'f-' + col.type"
            />
          </v-col>
        </v-row>
        <slot></slot>
        <v-divider></v-divider>
        <v-btn color="primary" type="submit" block>Save</v-btn>
      </v-form>
    </b-crud>
  </div>
</template>

<script>
import text from "./components/text-field";
import select from "./components/select";
import filePicker from "./components/file-picker";

export default {
  components: {
    "f-text": text,
    "f-select": select,
    "f-file-picker": filePicker,
  },
  props: {
    controller: String,
    title: String,
    mode: String,
  },
  methods: {
    async submit(ctrl) {
      let self = this;
      let mode = self.mode.toLowerCase();

      if (mode == "create") {
        console.log(ctrl.create);
        await ctrl.create();

        ctrl.showDialog = false;
      }

      if (mode == "edit" || mode == "update") {
        await ctrl.update();

        ctrl.showDialog = false;
      }
    },
  },
};
</script>